<template>
  <div class="picmanger">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png"
             style="margin-right:10px"
             alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>工作流</el-breadcrumb-item>
          <el-breadcrumb-item>图片展示</el-breadcrumb-item>
          <el-breadcrumb-item>轮播图设置</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div @click="refresh"
           class="refresh">
        <img :class="isRefresh ?'imgmove':''"
             width="16px"
             height="16px"
             src="@/assets/house/refresh.png"
             alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <div class="head">
        <h4>
          轮播图设置
          <!-- <span
            style="font-size: 12px !important;margin-left:20px;color:rgb(96, 197, 255);cursor: pointer;"
          >查看送审给我的任务</span> -->
        </h4>
        <!-- <p @click="changeUserForm">+创建筛选任务</p> -->
      </div>

      <div class="tabsbody">
        <el-tabs v-model="activeName"
                 @tab-click="handleClick"
                 type="border-card">
          <el-tab-pane name="0"
                       label="首页轮播图">
            <div class="rotation"
                 v-loading="isRefresh">
              <el-upload class="upload-demo"
                         action="#"
                         :show-file-list="false"
                         :auto-upload="false"
                         :on-change="uploadRotation">
                <div v-if="powersObj.manageWebsiteCarousel"
                    :style="{'backgroundColor': isSimple ? '#E27B02' : '#194897'}"
                     class="btn">
                  <img src="@/assets/workflow/upload.png"
                       alt="">
                  <p>上传轮播图</p>
                </div>
              </el-upload>

              <div style="width:1000px;margin:15px auto;">
                <div style="display:flex;align-items: center;justify-content: center;"
                     v-if="firstRoationList.length <= 0">
                  <img src="@/assets/piclist/nonr.png"
                       alt="">
                </div>
                <div class="rotlist"
                     v-for="(e,i) in firstRoationList"
                     @mouseleave="showChangeFlag = -1"
                     :key="i">
                  <el-image @mouseenter="showChangeFlag = i"
                            class="img"
                            fit="contain"
                            v-loading="carouselIndex==i"
                            :src="picPrefix + e.displayImage">
                    <div slot="placeholder"
                         class="image-slot">
                      <img src="@/assets/house/onloadpicin.png"
                           alt="">
                    </div>
                  </el-image>
                  <div v-show="showChangeFlag == i && e.id"
                       class="changeimg">
                    <el-upload class="upload-demo"
                               action="#"
                               :show-file-list="false"
                               :auto-upload="false"
                               :on-change="(file, fileList) => {changeUploadRotation(file, fileList, i)}">
                      <div>
                        <p>更改图片</p>
                      </div>
                    </el-upload>

                  </div>
                  <!-- <div class="img" :style="{backgroundImage:'url(' + picPrefix + e.sourceImage +')'}"></div> -->
                  <div class="text">
                    <div class="lei"
                         style="align-items: center;">
                      <p style="width:80px;">图片标题</p>
                      <el-input :disabled="!powersObj.manageWebsiteCarousel"
                                placeholder="必填，不超过40个字"
                                style="width:400px;"
                                maxlength="40"
                                v-model="e.title"
                                clearable>
                      </el-input>
                    </div>
                    <div class="lei">
                      <p style="width:80px;">图片简介</p>
                      <el-input placeholder="选填，不超过200个字"
                                :disabled="!powersObj.manageWebsiteCarousel"
                                v-model="e.desc"
                                maxlength="200"
                                style="width:400px;"
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 6}"
                                clearable>
                      </el-input>
                    </div>
                    <div class="lei"
                         style="align-items: center;">
                      <p style="width:80px;">图片链接</p>
                      <el-input placeholder="选填，不加链接则不跳转"
                                :disabled="!powersObj.manageWebsiteCarousel"
                                style="width:400px;"
                                v-model="e.url"
                                clearable>
                      </el-input>
                    </div>
                  </div>
                  <div class="robtn">
                    <div v-if="powersObj.manageWebsiteCarousel"
                         class="icon"
                         @click.stop="goTop(e,i,'firstRoationList')">
                      <div class="icon"></div>
                      <p>置顶</p>
                    </div>
                    <div v-if="powersObj.manageWebsiteCarousel"
                         class="del"
                         @click.stop="delRotation(e,i,'firstRoationList')">
                      <div></div>
                      <p>删除</p>
                    </div>
                    <div v-if="powersObj.manageWebsiteCarousel"
                         @click.stop="showCro(e,i,'firstRoationList')"
                         class="cu">
                      <div></div>
                      <p>裁剪</p>
                    </div>
                    <div class="see"
                         @click.stop="seeImg(e)">
                      <div></div>
                      <p>查看原图</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane name="1"
                       label="频道轮播图">
            <div class="rotation"
                 v-loading="isRefresh">

              <div class="tab">
                <p v-for="(e,i) in channelList"
                   :key="i"
                   @click="changeChannelRotation(e.id)"
                   :class="channelFlag == e.id ? isSimple ? 'simpleactive' : 'active' : ''">{{e.name}}</p>
              </div>
              <div style="height:60px;"></div>
              <el-upload class="upload-demo"
                         action="#"
                         :disabled="channelList[0].id == '99999999'"
                         :show-file-list="false"
                         :auto-upload="false"
                         :on-change="uploadRotationChannel">
                <div :style="{'backgroundColor': isSimple ? '#E27B02' : '#185ED3','cursor': channelList[0].id == '99999999' ? 'not-allowed' : 'pointer'}"
                     v-if="powersObj.manageWebsiteCarousel"
                     class="btn">
                  <img src="@/assets/workflow/upload.png"
                       alt="">
                  <p>上传轮播图</p>
                </div>
              </el-upload>

              <div style="width:1000px;margin:15px auto;">
                <div style="display:flex;align-items: center;justify-content: center;"
                     v-if="channelList[0].id == '99999999' || firstRoationChannelList.length <= 0">
                  <img src="@/assets/piclist/nonr.png"
                       alt="">
                </div>
                <div class="rotlist"
                     v-for="(e,i) in firstRoationChannelList"
                     @mouseleave="showChangeFlag = -1"
                     :key="i">
                  <el-image class="img"
                            fit="contain"
                            v-loading="carouselIndex==i"
                            @mouseenter="showChangeFlag = i"
                            :src="picPrefix + e.displayImage">
                    <div slot="placeholder"
                         class="image-slot">
                      <img src="@/assets/house/onloadpicin.png"
                           alt="">
                    </div>
                  </el-image>
                  <div v-show="showChangeFlag == i && e.id"
                       class="changeimg">
                    <el-upload class="upload-demo"
                               action="#"
                               :show-file-list="false"
                               :auto-upload="false"
                               :on-change="(file, fileList) => {changeUploadRotation(file, fileList, i)}">
                      <div>
                        <p>更改图片</p>
                      </div>
                    </el-upload>

                  </div>

                  <!-- <div class="img"></div> -->
                  <div class="text">
                    <div class="lei"
                         style="align-items: center;">
                      <p style="width:80px;">图片标题</p>
                      <el-input placeholder="必填，不超过40个字"
                                :disabled="!powersObj.manageWebsiteCarousel"
                                style="width:400px;"
                                maxlength="40"
                                v-model="e.title"
                                clearable>
                      </el-input>
                    </div>
                    <div class="lei">
                      <p style="width:80px;">图片简介</p>
                      <el-input placeholder="选填，不超过200个字"
                                :disabled="!powersObj.manageWebsiteCarousel"
                                v-model="e.desc"
                                maxlength="200"
                                style="width:400px;"
                                type="textarea"
                                :autosize="{ minRows: 4, maxRows: 6}"
                                clearable>
                      </el-input>
                    </div>
                    <div class="lei"
                         style="align-items: center;">
                      <p style="width:80px;">图片链接</p>
                      <el-input placeholder="选填，不加链接则不跳转"
                                :disabled="!powersObj.manageWebsiteCarousel"
                                style="width:400px;"
                                v-model="e.url"
                                clearable>
                      </el-input>
                    </div>
                  </div>
                  <div class="robtn">
                    <div v-if="powersObj.manageWebsiteCarousel"
                         class="icon"
                         @click.stop="goTop(e,i,'firstRoationChannelList')">
                      <div class="icon"></div>
                      <p>置顶</p>
                    </div>
                    <div v-if="powersObj.manageWebsiteCarousel"
                         class="del"
                         @click.stop="delRotation(e,i,'firstRoationChannelList')">
                      <div></div>
                      <p>删除</p>
                    </div>
                    <div v-if="powersObj.manageWebsiteCarousel"
                         @click.stop="showCro(e,i,'firstRoationChannelList')"
                         class="cu">
                      <div></div>
                      <p>裁剪</p>
                    </div>
                    <div class="see"
                         @click.stop="seeImg(e)">
                      <div></div>
                      <p>查看原图</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-tab-pane>

        </el-tabs>
      </div>

    </div>

    <div v-if="powersObj.manageWebsiteCarousel"
         class="bottombtn">
      <div class="btn">
        <!-- <el-button :disabled="isRefresh" @click="closeForm">取消</el-button> -->
        <el-button :disabled="isRefresh"
                   @click="submitForm()"
                   :style="{'border':'none','backgroundColor': isSimple ? '#E27B02' : '#194897'}"
                   type="primary">提交</el-button>
      </div>
    </div>

    <el-dialog :visible.sync="showCropper"
               top="6vh"
               width="60%"
               height="600"
               class="cropper-dialog"
               :close-on-click-modal="false"
               :before-close='closeCropper'
               append-to-body>
      <div slot="title" class="header-title" :style="{'padding':'15px 20px','box-sizing':'border-box','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}">
        <div>图片裁剪</div>
      </div>
      <div style="width:100%;height:650px;">
        <!-- <ImgCutter></ImgCutter> -->
        <div style="display:flex; align-items: center;margin-bottom:20px;">
          <el-row style="width:100%;">
            <el-col :span="20">
              <p style="font-weight:bold;margin-bottom:10px;">截图比例选择:</p>
              <el-radio-group v-model="radioFix"
                              size="medium"
                              :fill="isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'"
                              @change="radioChange">
                <el-radio label="1,1"
                          border>1：1</el-radio>
                <el-radio label="4,3"
                          border>4：3</el-radio>
                <el-radio label="2,1"
                          border>2：1</el-radio>
                <el-radio label="16,9"
                          border>16：9</el-radio>
                <el-radio label="10,2"
                          border>10：2</el-radio>
              </el-radio-group>
            </el-col>
            <el-col :span="4">
              <p style="font-weight:bold;margin-bottom:10px;">图片缩放</p>
              <el-button @click="changeScale(1)">放大</el-button>
              <el-button @click="changeScale(-1)">缩小</el-button>
            </el-col>
          </el-row>

        </div>
        <vue-cropper v-loading="cropperLoading"
                     :element-loading-text="loadingText"
                     element-loading-spinner="el-icon-loading"
                     style="height:550px;width:100%;"
                     :img='option.img'
                     id="corpper"
                     ref="cropper"
                     :outputSize="option.outputSize"
                     :outputType="option.outputType"
                     :info="option.info"
                     :canScale="option.canScale"
                     :autoCrop="option.autoCrop"
                     :autoCropWidth="option.autoCropWidth"
                     :autoCropHeight="option.autoCropHeight"
                     :fixed="option.fixed"
                     :fixedNumber="option.fixedNumber"
                     :full="option.full"
                     :fixedBox="option.fixedBox"
                     :canMove="option.canMove"
                     :canMoveBox="option.canMoveBox"
                     :original="option.original"
                     :centerBox="option.centerBox"
                     :height="option.height"
                     :infoTrue="option.infoTrue"
                     :maxImgSize="option.maxImgSize"
                     :enlarge="option.enlarge"
                     :mode="option.mode"
                     @imgLoad="imgLoad" />

      </div>

      <div slot="footer"
           style="margin-top:30px;">
        <el-button class="cancel-btn"
                   size="small"
                   @click.native="closeCropper">取消</el-button>
        <el-button :disabled="cropperLoading"
                   size="small"
                   type="primary"
                   :loading="loading"
                   :style="{'border':'none','backgroundColor': isCustom ? customColor : isSimple ? '#FD9112' : '#185ED3'}"
                   @click="getCropperImg">完成</el-button>
      </div>
    </el-dialog>

    <transition name="el-fade-in-linear">
      <div class="seeimg"
           ref="seeimg"
           @click="closeImg">
        <el-image style="width:80%;height:80%"
                  fit="contain"
                  oncontextmenu="return false;"
                  :src='cropperInfo.src'>
          <div slot="placeholder"
               class="image-slot">
            <img src="@/assets/house/onloadpicin.png"
                 alt="">
          </div>
        </el-image>
      </div>
    </transition>

  </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import { subpictable } from "@/components/index";
import { mapGetters } from "vuex";
import { picPrefix } from "@/constants/piccommon";
import {
  uploadPic,
  uploadPicChunk,
  uploadPicChunkMerge,
  getFileInfoById,
  getFileInfoByHash
} from "@/api/file";
import {
  listWebsiteColumn,
  listWebsiteCarousel,
  updateWebsiteCarousel,
  addWebsiteCarousel,
  deleteWebsiteCarousel,
  getWebsiteCarousel
} from "@/api/website";
import getMD5 from "@/plugins/getMD5";
import { getDate, formatConversion } from "@/plugins/getdate";
import { powersObj } from "@/constants/powers";
export default {
  components: {
    subpictable, VueCropper
  },
  computed: {
    ...mapGetters(["createUid"]),
  },
  data () {
    return {
      powersObj,

      loadingText: '图片正在加载中，请耐心等待~',


      picPrefix,
      activeName: '0',

      //修改图片的轮播图位置
      firstRoationIndex: -1,
      firstRoationChannelIndex: -1,

      columnId: 0,

      firstRoationList: [],
      newRoationList: [],
      addRoationLength: 0,

      firstRoationChannelList: [],
      newRoationChannelList: [],
      addRoationChannelLength: 0,

      isRefresh: false,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      timeInt: null,

      input: '',
      //频道列表
      channelList: [],
      channelFlag: 0,

      //图片裁剪相关
      cropperInfo: {},
      showCropper: false,
      cropperLoading: false,
      loading: false,
      radioFix: '16,9',
      fixedNumberX: 0,
      fixedNumberY: 0,
      option: {
        img: '',             //裁剪图片的地址
        outputSize: 1,       //裁剪生成图片的质量(可选0.1 - 1)
        outputType: 'png',  //裁剪生成图片的格式（jpeg || png || webp）
        info: true,          //图片大小信息
        canScale: true,      //图片是否允许滚轮缩放
        autoCrop: true,      //是否默认生成截图框
        // autoCropWidth: 230,  //默认生成截图框宽度
        // autoCropHeight: 150, //默认生成截图框高度
        fixed: true,         //是否开启截图框宽高固定比例
        fixedNumber: [16, 9], //截图框的宽高比例
        full: false,         //false按原比例裁切图片，不失真
        fixedBox: false,      //固定截图框大小，不允许改变
        canMove: false,      //上传图片是否可以移动
        canMoveBox: true,    //截图框能否拖动
        original: false,     //上传图片按照原始比例渲染
        centerBox: true,    //截图框是否被限制在图片里面
        height: true,        //是否按照设备的dpr 输出等比例图片
        infoTrue: false,     //true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000,    //限制图片最大宽度和高度
        enlarge: 1,          //图片根据截图框输出比例倍数
        mode: '100% auto'  //图片默认渲染方式
      },
      //裁剪图片上传
      kuai: 0,


      showChangeFlag: -1,

      carouselIndex: -1,//轮播图index
    };
  },
  methods: {


    //blob转file
    blobToFile (newBlob, fileName) {
      newBlob.lastModifiedDate = new Date();
      newBlob.name = fileName;
      return newBlob;
    },

    //提交
    async submitForm (formName) {

      if (this.activeName == '0') {
        if (this.firstRoationList.length <= 0) {
          this.$message.warning('请添加轮播图！')
          return false;
        }

        for (let i = 0; i < this.newRoationList.length; i++) {
          this.addWebsiteCarouselAsync(this.newRoationList[i])
        }

        for (let i = 0; i < this.firstRoationList.length; i++) {
          if (this.firstRoationList[i].id) {
            await updateWebsiteCarousel(this.firstRoationList[i])
          }
        }

        setTimeout(() => {
          if (this.addRoationLength == this.newRoationList.length) {
            this.$message.success('创建成功！');
            this.newRoationList = []
            this.addRoationLength = 0

          } else {
            let errorLength = this.newRoationList.length - this.addRoationLength
            this.$message.warning('有' + errorLength + '个轮播图创建失败，其他创建成功！')
            this.newRoationList = []
            this.addRoationLength = 0
          }

          let val = {
            page: 0,
            pageSize: 50,
            columnId: 0
          }
          this.listWebsiteCarouselAsync(val)

        }, 1000);
      } else {
        if (this.channelList[0].id == '99999999') {
          this.$message.warning('请添加栏目！')
          return false;
        }
        if (this.firstRoationChannelList.length <= 0) {
          this.$message.warning('请添加轮播图！')
          return false;
        }
        for (let i = 0; i < this.newRoationChannelList.length; i++) {
          let info = await addWebsiteCarousel(this.newRoationChannelList[i])
          if (info.status) {
            this.addRoationChannelLength++
          }
        }

        for (let i = 0; i < this.firstRoationChannelList.length; i++) {
          if (this.firstRoationChannelList[i].id) {
            await updateWebsiteCarousel(this.firstRoationChannelList[i])
          }
        }

        setTimeout(() => {
          if (this.addRoationChannelLength == this.newRoationChannelList.length) {
            this.$message.success('创建成功！');
            this.newRoationChannelList = []
            this.addRoationChannelLength = 0

          } else {
            let errorLength = this.newRoationChannelList.length - this.addRoationChannelLength
            this.$message.warning('有' + errorLength + '个轮播图创建失败，其他创建成功！')
            this.newRoationChannelList = []
            this.addRoationChannelLength = 0
          }

          let val = {
            page: 0,
            pageSize: 50,
            columnId: this.channelFlag
          }
          this.listWebsiteCarouselChannelAsync(val)

        }, 1000);
      }

    },

    handleClick () {
      if (this.activeName == 0) {
        this.columnId = 0
      } else {
        this.columnId = this.channelFlag
      }
    },

    uploadRotationChannel (file, fileList) {
      // console.log(file);
      this.isRefresh = true
      const type = ["image/jpeg", "image/gif"];
      let isJPG = type.indexOf(file.raw.type) > -1;
      if (isJPG) {
        if (file.raw.name.substring(file.raw.name.length - 4) === "jpeg") {
          isJPG = false;
        }
      }
      if (!isJPG) {
        this.$message.error("上传图片格式只能为jpg");
        this.isRefresh = false
        return false
      }

      this.myUploadRot(file, 'upRotChannel');

    },
    uploadRotation (file, fileList) {
      // console.log(file);
      this.isRefresh = true
      const type = ["image/jpeg", "image/gif"];
      let isJPG = type.indexOf(file.raw.type) > -1;
      if (isJPG) {
        if (file.raw.name.substring(file.raw.name.length - 4) === "jpeg") {
          isJPG = false;
        }
      }
      if (!isJPG) {
        this.$message.error("上传图片格式只能为jpg");
        this.isRefresh = false
        return false
      }

      this.myUploadRot(file, 'upRot');

    },


    changeUploadRotation (file, fileList, i) {
      console.log(file, fileList, i);
      this.carouselIndex = i
      console.log(this.firstRoationList);
      console.log(this.firstRoationChannelList);
      this.firstRoationIndex = i
      const type = ["image/jpeg", "image/gif"];
      let isJPG = type.indexOf(file.raw.type) > -1;
      if (isJPG) {
        if (file.raw.name.substring(file.raw.name.length - 4) === "jpeg") {
          isJPG = false;
        }
      }
      if (!isJPG) {
        this.$message.error("上传图片格式只能为jpg");
        this.carouselIndex = -1
        return false
      }

      this.myUploadRot(file, 'changeUpRot');

    },

    // 放大缩小
    changeScale (num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },

    //初始化函数
    imgLoad (msg) {
      this.cropperLoading = false
      console.log("工具初始化函数=====" + msg)
      // console.log(this.option);
    },
    closeCropper () {
      this.showCropper = false
      this.cropperInfo = {}
      this.option = {
        img: '',             //裁剪图片的地址
        outputSize: 1,       //裁剪生成图片的质量(可选0.1 - 1)
        outputType: 'png',  //裁剪生成图片的格式（jpeg || png || webp）
        info: true,          //图片大小信息
        canScale: true,      //图片是否允许滚轮缩放
        autoCrop: true,      //是否默认生成截图框
        fixed: true,         //是否开启截图框宽高固定比例
        fixedNumber: [16, 9], //截图框的宽高比例
        full: false,         //false按原比例裁切图片，不失真
        fixedBox: false,      //固定截图框大小，不允许改变
        canMove: false,      //上传图片是否可以移动
        canMoveBox: true,    //截图框能否拖动
        original: false,     //上传图片按照原始比例渲染
        centerBox: true,    //截图框是否被限制在图片里面
        height: true,        //是否按照设备的dpr 输出等比例图片
        infoTrue: false,     //true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000,    //限制图片最大宽度和高度
        enlarge: 1,          //图片根据截图框输出比例倍数
        mode: '100% auto'  //图片默认渲染方式
      }
    },
    getCropperImg () {
      this.loadingText = "正在修改中，请耐心等待~"
      this.cropperLoading = true
      this.$refs.cropper.getCropBlob(async (data) => {
        let blobIndex = Math.ceil(Math.random() * 19999999)
        let blob = this.blobToFile(data, '截图内容' + blobIndex + '.jpg')
        // let formData = new FormData();
        // let fd = new FormData();
        // fd.append("file", data);
        // console.log(blob);

        this.myUpload(blob)
      })
    },

    radioChange () {
      console.log(this.option.fixedNumber);
      let val = this.radioFix.split(',')
      let valN = []
      val.forEach((e) => {
        valN.push(Number(e))
      })
      this.option.fixedNumber = valN
      setTimeout(() => {
        this.$refs.cropper.goAutoCrop()
      }, 200);
    },
    //自定义上传
    myUpload (val) {
      let bytesPerPiece;
      let totalPieces;
      let fileMD5;

      if (val.size > 400000) {
        bytesPerPiece = 260000;
      } else {
        bytesPerPiece = 9888;
      }

      getMD5(val, md5 => {
        fileMD5 = md5;

        // console.log(fileMD5);

        this.getFileInfoByHashAsync(
          fileMD5,
          val,
          bytesPerPiece,
          totalPieces
        );
      });
    },
    //自定义上传
    myUploadRot (val, text) {
      let bytesPerPiece;
      let totalPieces;
      let fileMD5;

      if (val.size > 400000) {
        bytesPerPiece = 260000;
      } else {
        bytesPerPiece = 9888;
      }

      getMD5(val.raw, md5 => {
        fileMD5 = md5;

        // console.log(fileMD5);

        this.getFileInfoByHashAsync(
          fileMD5,
          val.raw,
          bytesPerPiece,
          totalPieces,
          text
        );
      });


    },
    //通过md5查询图片
    async getFileInfoByHashAsync (val, blob, b, t, text) {

      let { status, data, message } = await getFileInfoByHash(val);
      if (status) {
        this.cropperLoading = false
        this.isRefresh = false
        if (text == 'upRot') {
          this.newRoationList.unshift({
            columnId: this.columnId,
            title: '',
            desc: '',
            url: '',
            sourceImage: data.savepath,
            displayImage: data.savepath
          })
          this.firstRoationList = this.newRoationList.concat(this.firstRoationList)
          this.firstRoationList = Array.from(new Set(this.firstRoationList))
          console.log('轮播图图片已存在', data);
          // console.log(this.firstRoationList);
        } else if (text == 'upRotChannel') {
          this.newRoationChannelList.unshift({
            columnId: this.channelFlag,
            title: '',
            desc: '',
            url: '',
            sourceImage: data.savepath,
            displayImage: data.savepath
          })
          this.firstRoationChannelList = this.newRoationChannelList.concat(this.firstRoationChannelList)
          this.firstRoationChannelList = Array.from(new Set(this.firstRoationChannelList))
          console.log('裁剪图片已存在', data);
          console.log(this.cropperInfo);
          // let updateCarousel = await updateWebsiteCarousel(params);

        } else if (text == 'changeUpRot') {
          if (this.activeName == '0') {
            console.log(data, this.firstRoationList);
            this.firstRoationList[this.carouselIndex].displayImage = data.savepath
            this.firstRoationList[this.carouselIndex].sourceImage = data.savepath
            this.updateWebsiteCarouselAsync(this.firstRoationList[this.carouselIndex])
          } else {
            console.log(data, this.firstRoationChannelList);
            this.firstRoationChannelList[this.carouselIndex].displayImage = data.savepath
            this.firstRoationChannelList[this.carouselIndex].sourceImage = data.savepath
            this.updateWebsiteCarouselAsync(this.firstRoationChannelList[this.carouselIndex])
          }
        } else {
          if (this.cropperInfo.text) {
            if (this.cropperInfo.text == 'firstRoationChannelList') {
              this.firstRoationChannelList[this.cropperInfo.index].displayImage = data.savepath
            } else if (this.cropperInfo.text == 'firstRoationList') {
              this.firstRoationList[this.cropperInfo.index].displayImage = data.savepath
            }
          } else {
            this.cropperInfo.displayImage = data.savepath
            this.updateWebsiteCarouselAsync(this.cropperInfo)
          }

          console.log('裁剪图片已存在', data);
        }
      } else {
        console.log('图片不存在');
        this.fragmentation(val, blob, b, t, text);
      }
    },
    //分片上传
    async fragmentation (val, blob, bytesPerPiece, totalPieces, text) {
      var start = 0;
      var end;
      var index = 0;
      var filesize = blob.size;
      var filename = blob.name;

      totalPieces = Math.ceil(filesize / bytesPerPiece);

      while (start < filesize) {
        end = start + bytesPerPiece;
        if (end > filesize) {
          end = filesize;
        }

        var chunk = blob.slice(start, end); //切割文件
        var sliceIndex = filename + index;
        var formData = new FormData();
        formData.append("file", chunk);

        let params = {
          chunk: index,
          hash: val
        };


        if (index < totalPieces) {
          // console.log('分片次数',index)
          await this.uploadPicChunkAsync(params, formData, blob);
        }
        if (index === totalPieces - 1) {
          // console.log('分片合并')
          params = {
            chunkCount: totalPieces,
            filename: sliceIndex,
            hash: val
          };
          await this.uploadPicChunkMergeAsync(params, blob, text);
        }
        start = end;
        index++;
      }
    },
    //分片上传接口第一步
    async uploadPicChunkAsync (params, val, blob) {
      let { status, data, message } = await uploadPicChunk(params, val);
      if (!status) {
        console.log('分片第一步出错');
        // this.uploadPicAsync(blob,i);
        // this.uploadErrorLength++
      }
    },
    //分片上传接口第二步
    async uploadPicChunkMergeAsync (params, blob, text) {
      let { status, data, message } = await uploadPicChunkMerge(params);
      if (status) {
        if (text == 'upRot') {
          this.newRoationList.unshift({
            columnId: this.columnId,
            title: '',
            desc: '',
            url: '',
            sourceImage: data.savepath,
            displayImage: data.savepath
          })
          this.firstRoationList = this.newRoationList.concat(this.firstRoationList)
          console.log('轮播图-分片上传成功', data);
        } else if (text == 'upRotChannel') {
          this.newRoationChannelList.unshift({
            columnId: this.columnId,
            title: '',
            desc: '',
            url: '',
            sourceImage: data.savepath,
            displayImage: data.savepath
          })
          this.firstRoationChannelList = this.newRoationChannelList.concat(this.firstRoationChannelList)
          console.log('裁剪图片已存在', data);
        } else {
          if (this.cropperInfo.text) {
            if (this.cropperInfo.text == 'firstRoationChannelList') {
              this.firstRoationChannelList[this.cropperInfo.index].displayImage = data.savepath
            } else if (this.cropperInfo.text == 'firstRoationList') {
              this.firstRoationList[this.cropperInfo.index].displayImage = data.savepath
            }
            this.$message.success('裁剪成功！')
            this.showCropper = false
          } else {
            this.cropperInfo.displayImage = data.savepath
            console.log(this.cropperInfo);
            if (this.activeName == '0') {
              this.firstRoationList[this.carouselIndex].displayImage = data.savepath
              this.firstRoationList[this.carouselIndex].sourceImage = data.savepath
              this.updateWebsiteCarouselAsync(this.firstRoationList[this.carouselIndex])
            } else {
              console.log(data, this.firstRoationChannelList);
              this.firstRoationChannelList[this.carouselIndex].displayImage = data.savepath
              this.firstRoationChannelList[this.carouselIndex].sourceImage = data.savepath
              this.updateWebsiteCarouselAsync(this.firstRoationChannelList[this.carouselIndex])
            }
          }
          console.log('裁剪-分片上传成功', data);
        }

      } else {
        this.$message.error('图片上传失败,请重试！')
        console.log('分片合并出错');
      }
      this.isRefresh = false
      this.cropperLoading = false
    },


    async changeChannelRotation (id) {
      this.channelFlag = id
      let valChannel = {
        page: 0,
        pageSize: 50,
        columnId: this.channelFlag
      }
      let list = await listWebsiteCarousel(valChannel)
      this.firstRoationChannelList = list.data
    },

    //刷新表格
    refresh () {
      let val = {
        page: 0,
        pageSize: 50,
        columnId: 0
      }
      this.listWebsiteCarouselAsync(val)



      let valC = {
        page: 0,
        pageSize: 50,
        parentId: 0
      }
      this.listWebsiteColumnAsync(valC)
    },

    //打开裁剪工具
    async showCro (e, i, text) {
      this.option = {
        img: '',             //裁剪图片的地址
        outputSize: 1,       //裁剪生成图片的质量(可选0.1 - 1)
        outputType: 'png',  //裁剪生成图片的格式（jpeg || png || webp）
        info: true,          //图片大小信息
        canScale: true,      //图片是否允许滚轮缩放
        autoCrop: true,      //是否默认生成截图框
        fixed: true,         //是否开启截图框宽高固定比例
        fixedNumber: [16, 9], //截图框的宽高比例
        full: false,         //false按原比例裁切图片，不失真
        fixedBox: false,      //固定截图框大小，不允许改变
        canMove: false,      //上传图片是否可以移动
        canMoveBox: true,    //截图框能否拖动
        original: false,     //上传图片按照原始比例渲染
        centerBox: true,    //截图框是否被限制在图片里面
        height: true,        //是否按照设备的dpr 输出等比例图片
        infoTrue: false,     //true为展示真实输出图片宽高，false展示看到的截图框宽高
        maxImgSize: 3000,    //限制图片最大宽度和高度
        enlarge: 1,          //图片根据截图框输出比例倍数
        mode: '100% auto'  //图片默认渲染方式
      }
      this.cropperLoading = true
      if (e.id) {
        let info = await getWebsiteCarousel(e.id)
        this.cropperInfo = info.data
        this.option.img = picPrefix + info.data.sourceImage
      } else {
        this.cropperInfo = e
        this.cropperInfo.text = text
        this.cropperInfo.index = i
        this.option.img = picPrefix + e.sourceImage
        this.cropperLoading = false
      }
      this.showCropper = true
    },
    //查看原图
    async seeImg (e) {
      if (e.id) {
        let info = await getWebsiteCarousel(e.id)
        this.cropperInfo = info.data
        this.cropperInfo.src = picPrefix + this.cropperInfo.sourceImage
        this.$refs.seeimg.style.display = 'flex'
        setTimeout(() => {
          this.$refs.seeimg.style.opacity = 1
        }, 200);
      } else {
        this.cropperInfo = e
        this.cropperInfo.src = picPrefix + this.cropperInfo.sourceImage
        this.$refs.seeimg.style.display = 'flex'
        setTimeout(() => {
          this.$refs.seeimg.style.opacity = 1
        }, 200);
      }

    },
    //置顶
    async goTop (val, i, text) {
      this.$confirm("确认置顶吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          if (val.id) {
            val.sort = Date.parse(new Date()) / 1000
            this.updateWebsiteCarouselAsync(val)
            this.handleClick()
            setTimeout(() => {
              let val = {
                page: 0,
                pageSize: 50,
                columnId: this.columnId
              }
              this.listWebsiteCarouselAsync(val)
            }, 1000);
          } else {
            if (text == 'firstRoationChannelList') {
              this.firstRoationChannelList.splice(i, 1)
              this.firstRoationChannelList.unshift(val)
            } else {
              this.firstRoationList.splice(i, 1)
              this.firstRoationList.unshift(val)
            }
          }

        })
    },


    //关闭查看图片
    closeImg () {
      this.$refs.seeimg.style.opacity = 0
      setTimeout(() => {
        this.$refs.seeimg.style.display = 'none'
      }, 1000);
    },


    //删除
    delRotation (val, i, text) {
      this.$confirm("确认删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        confirmButtonClass:this.isCustom ? this.custom == 'xugong' ? 'xgfirm' : 'wcfirm' :this.isSimple ? 'mySimplePriConfirm' : 'myPriConfirm',//点击删除
      })
        .then(() => {
          if (val.id) {
            this.deleteWebsiteCarouselAsync(val.id)
          } else {
            this.$message.success('删除成功！')
            if (text == 'firstRoationChannelList') {
              this.firstRoationChannelList.splice(i, 1)
              this.newRoationChannelList.splice(i, 1)
            } else {
              this.firstRoationList.splice(i, 1)
              this.newRoationList.splice(i, 1)
            }

          }
        })
        .catch(() => {
          // this.$message({
          //   type: "info",
          //   message: "已取消"
          // });
        });
    },

    //判断是哪里的轮播图
    checkWebsiteCarouse () {
      if (this.activeName == '0') {
        let val = {
          page: 0,
          pageSize: 50,
          columnId: 0
        }
        this.listWebsiteCarouselAsync(val)
      } else {
        let val = {
          page: 0,
          pageSize: 50,
          columnId: this.channelFlag
        }
        this.listWebsiteCarouselChannelAsync(val)
      }
    },


    //修改
    async updateWebsiteCarouselAsync (val) {
      let { status, data, message, errors } = await updateWebsiteCarousel(val);
      if (status) {
        this.$message.success('修改成功！');

        this.checkWebsiteCarouse()

        this.loadingText = '图片正在加载中，请耐心等待~'
        this.showCropper = false
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
      this.carouselIndex = -1
    },


    //添加
    async addWebsiteCarouselAsync (val) {
      let { status, data, message, errors } = await addWebsiteCarousel(val);
      if (status) {
        this.addRoationLength++
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //获取
    async getWebsiteCarouselAsync (val) {
      let { status, data, message, errors } = await getWebsiteCarousel(val);
      if (status) {

      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },

    //删除
    async deleteWebsiteCarouselAsync (val) {
      let { status, data, message, errors } = await deleteWebsiteCarousel(val);
      if (status) {
        this.$message.success('删除成功！');
        this.checkWebsiteCarouse()
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }
    },
    //获取首页
    async listWebsiteCarouselAsync (val) {
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await listWebsiteCarousel(val);
      if (status) {
        this.firstRoationList = data
        this.firstRoationList = this.firstRoationList.reverse()
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }

      this.isRefresh = false
    },

    //获取频道
    async listWebsiteCarouselChannelAsync (val) {
      this.isRefresh = true
      let { status, data, message, pagination, errors } = await listWebsiteCarousel(val);
      if (status) {
        this.firstRoationChannelList = data
        this.firstRoationChannelList = this.firstRoationChannelList.reverse()
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }

      this.isRefresh = false
    },

    //获取频道
    async listWebsiteColumnAsync (val) {
      let { status, data, message, pagination, errors } = await listWebsiteColumn(val);
      if (status) {
        this.channelList = data

        if (this.channelList.length <= 0) {
          this.channelList.push({ id: '99999999', name: '暂无频道' })
        }
        this.channelFlag = this.channelList[0].id


        let valChannel = {
          page: 0,
          pageSize: 50,
          columnId: this.channelFlag
        }
        this.listWebsiteCarouselChannelAsync(valChannel)
      } else {
        let errortext = ''
        for (const key in errors) {
          errortext += errors[key]
        }
        this.$message.error({ message: message + errortext });
      }

    },
  },
  created () {
    let val = {
      page: 0,
      pageSize: 50,
      columnId: 0
    }
    this.listWebsiteCarouselAsync(val)



    let valC = {
      page: 0,
      pageSize: 50,
      parentId: 0
    }
    this.listWebsiteColumnAsync(valC)



    // this.handleCurrentChange(this.currentPage);
    // this.timeInt = setInterval(() => {
    //   this.handleCurrentChange(this.currentPage);
    // }, 90000);
  },
  beforeDestroy () {
    // 组件销毁前调用
    // clearTimeout(this.timeInt);
  },
  mounted () { },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./rotationset.scss";
@import "@/constants/elHeader.scss";
.pagination {
  position: absolute;
  right: 30px;
  bottom: 30px;
}

.choose {
  display: flex;
  align-items: center;
}

/deep/ .el-tabs__content {
  background: #f8f8f8;
}

.bottombtn {
  min-width: calc(100vw - 62px);
  // width: 100%;
  height: 80px;
  background: #fff;
  box-shadow: 0 -2px 6px -2px rgba(0, 0, 0, 0.2);
  border-top: 1px solid #e1e1e1;
  display: flex;
  align-items: center;
  position: fixed;
  bottom: 0;
  right: 0;
  // top: 0;
  z-index: 5;
  .btn {
    margin-left: auto;
    margin-right: 45px;
  }
}

.bottombtn /deep/ .el-button {
  width: 100px;
  height: 40px;
  font-size: 14px;
}
.bottombtn /deep/ .el-button--primary {
  background-color: #185ed3;
}

/deep/ .upload-demo {
  display: flex;
  justify-content: center;
}
.image-slot {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>